<template>
  <div class="standard-question-content">
    <ResponseGrid
      :responses="sortedResponses"
      @select-response="$emit('select-response', $event)"
      @show-image="$emit('show-image', $event)"
      @show-information="$emit('show-information', $event)"
    />
  </div>
</template>

<script>
import ResponseGrid from './ResponseGrid.vue';

export default {
  name: 'StandardQuestion',
  components: {
    ResponseGrid,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  emits: ['select-response', 'show-image', 'show-information'],
  computed: {
    sortedResponses() {
      // Ensure responses are always sorted by their position property
      return [...this.question.responses].sort((a, b) => a.position - b.position);
    },
  },
};
</script>

<style lang="scss" scoped>
.standard-question-content {
  padding: 16px;
}
</style>